import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DateTimePickerDateObj } from '../../../../../../../ui/date-time-picker/date-time-picker.component';
import { AuthService } from '../../../../../../auth/auth.service';
import { WorkShiftService } from '../../../../../work-shift.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-period-filter',
  templateUrl: './tickets-period-filter.component.html',
  styleUrls: ['./tickets-period-filter.component.scss'],
  standalone: false,
})
export class TicketsPeriodFilterComponent {
  public moment = require('moment');
  public isOpenFilter = true;
  public dateRangeTooltip = 'Указанный диапазон дат не должен превышать 100 дней';
  public endDateDefaultTime = { hour: 23, minute: 59, second: 59 };
  private maxRangeDays = 100;

  @Input() ticketsPeriodFilter;

  constructor(
    private authService: AuthService,
    private workShiftService: WorkShiftService
  ) {}

  public onToggleFilter(): void {
    this.isOpenFilter = !this.isOpenFilter;
    this.workShiftService.filterCollapse$.next(true);
  }

  public onChangeStartTemplatePeriodDate(dateObj: DateTimePickerDateObj): void {
    const startDate = this.ticketsPeriodFilter.dateRange.startDate;
    const isInitialEmission = this.isInitialDateEmission(dateObj, startDate);

    if (dateObj.dateMillis) {
      startDate.dateObj = dateObj;
    } else {
      startDate.dateObj = null;
    }

    if (isInitialEmission) {
      return;
    }

    const startValue = dateObj.dateMillis ? this.moment(dateObj.dateMillis) : null;
    this.setPickerRange(
      this.ticketsPeriodFilter.dateRange.endDate,
      startValue ? startValue.clone().startOf('day')._d : null,
      startValue ? startValue.clone().add(this.maxRangeDays, 'days').endOf('day')._d : null
    );
  }

  public onChangeEndTemplatePeriodDate(dateObj: DateTimePickerDateObj): void {
    const endDate = this.ticketsPeriodFilter.dateRange.endDate;
    const isInitialEmission = this.isInitialDateEmission(dateObj, endDate);

    if (dateObj.dateMillis) {
      endDate.dateObj = dateObj;
    } else {
      endDate.dateObj = null;
    }

    if (isInitialEmission) {
      return;
    }

    const endValue = dateObj.dateMillis ? this.moment(dateObj.dateMillis) : null;
    this.setPickerRange(
      this.ticketsPeriodFilter.dateRange.startDate,
      endValue ? endValue.clone().subtract(this.maxRangeDays, 'days').startOf('day')._d : null,
      endValue ? endValue.clone().endOf('day')._d : null
    );
  }

  private isInitialDateEmission(dateObj: DateTimePickerDateObj, pickerState): boolean {
    return !pickerState.options && !!dateObj.dateMillis && +pickerState.initDate === dateObj.dateMillis;
  }

  // Обновляет options пикера только при реальном изменении диапазона,
  // чтобы не пересоздавать объект на каждый emit и не зациклить change detection.
  private setPickerRange(pickerState, minDate, maxDate): void {
    const current = pickerState.options;

    if (current && +current.minDate === +minDate && +current.maxDate === +maxDate) {
      return;
    }

    pickerState.options = {
      minDate: minDate,
      maxDate: maxDate,
      tooltip: this.dateRangeTooltip,
    };
  }

  public onChangeDistricts(districts): void {
    this.ticketsPeriodFilter.districtsSelected = districts;
  }

  public onChangeTicketsTypes(ticketsTypes): void {
    this.ticketsPeriodFilter.ticketTypesSelected = ticketsTypes;
  }

  public onChangeBrigades(brigades): void {
    this.ticketsPeriodFilter.brigadesSelected = brigades;
  }

  public onChangeVkStatues(ticketsVkStatues): void {
    this.ticketsPeriodFilter.ticketsVkStatusesSelected = ticketsVkStatues;
  }

  public onChangeHdStatues(ticketsHdStatues): void {
    this.ticketsPeriodFilter.ticketHdStatusesSelected = ticketsHdStatues;
  }

  public onChangeTypeGPs(typeGP): void {
    this.ticketsPeriodFilter.typeGPSelected = typeGP;

    // Синхронизируем подтипы ГП на основе выбранных типов ГП
    if (this.ticketsPeriodFilter.syncGPSubtypesBasedOnTypes) {
      this.ticketsPeriodFilter.syncGPSubtypesBasedOnTypes();
    }
  }

  public onChangeSubtypeGPs(subtypeGP): void {
    this.ticketsPeriodFilter.subtypeGPSelected = subtypeGP;
  }

  public onChangeResponsibleGroups(responsibleGroups): void {
    this.ticketsPeriodFilter.responsibleGroupsSelected = responsibleGroups;

    // Синхронизируем ответственных пользователей на основе выбранных групп
    if (this.ticketsPeriodFilter.syncResponsibleUsersBasedOnGroups) {
      this.ticketsPeriodFilter.syncResponsibleUsersBasedOnGroups();
    }
  }

  public onChangeResponsibleUsers(responsibleUsers): void {
    this.ticketsPeriodFilter.responsibleUsersSelected = responsibleUsers;
  }

  public onApplyFilter(): void {
    this.ticketsPeriodFilter.applyFilter();
  }

  public onResetFilter(): void {
    this.ticketsPeriodFilter.resetFilter();
  }

  public onExport(): void {
    this.ticketsPeriodFilter.exportFilter();
  }

  public isGRSUser() {
    return this.authService.isGRSUser();
  }
}
